import Loading from "common/fragments/Loading";
import { IPanelProps, Panel } from "core/decorators/Panel";
import React from "react";
import Query from "core/api/QueryComponent";
import labelProvider from '../learningSummary/LearningSummary.labels';
import { CreditSummaryView } from "./CreditSummaryView";
import DropdownSelect from "common/form/widgets/common/DropdownSelect";
import { SeparatorView } from "common/views/separator/Separator.view";
import Label from "core/components/label/Label";
import { BlockView } from "common/views/block/BlockView.view";
import {CreditEntriesUser, CreditUserCount} from "./CreditSummary";
import TheAcademyCreditConfig from "./TheAcademyCreditConfig";

const { Labels } = labelProvider;

function mapCreditEntryParams(pageCount, globalParams: any = {}) {
	const params = {
		granted: true,
		pageSize: pageCount,
	}
	if (globalParams.creditTypeIds) {
		params["creditTypeIds"] = globalParams.creditTypeIds;
	}
	
	return {params};
}


let yearOptions = [{label:'Total', value: 'Total'}];

interface ICreditState {
	selectedYear: string;
}

/**
 * CECPECreditSummaryPanel displays granted credits summary for the-academy context
 *
 */
@Panel({ id: "The-Academy-Credits-summary", configClass: TheAcademyCreditConfig, pageParams: true, labelProvider })
export class TheAcademyCreditSummaryPanel extends React.Component<IPanelProps<TheAcademyCreditConfig>, ICreditState> {
	constructor(props) {
		super(props);
		this.state = {selectedYear: 'Total'};
    }

	private getFilteredSummaryData = (data) => {
		const {config} = this.props;
		let result = [...data];
		let summaryData = [];
		const {selectedYear} = this.state;

		yearOptions = result.reduce((years, currentItem) => {
			const completedYear = new Date(currentItem.completedOn).getFullYear().toString();
			if(!years.some((i) => i.value === completedYear)){
				years.push({label:completedYear, value: completedYear});
			}
			return years;
		},yearOptions);

		if(selectedYear !== 'Total'){
			result = data.filter(credit=>credit.completedOn.includes(selectedYear));
		}

		let summary = result.reduce((acc,credit) => {
			if(config.creditClaimParams && config.creditClaimParams['ceCreditClaim'] && config.creditClaimParams['ceCreditClaim'].includes(credit.type.name)){
				acc['CE'] += credit.value;
			} else if (config.creditClaimParams && config.creditClaimParams['cpeCreditClaim'] && config.creditClaimParams['cpeCreditClaim'].includes(credit.type.name)) {
				acc['CPE'] += credit.value;
			}
			acc['Total'] += credit.value;
			return acc;
		},{Total: 0, CE: 0, CPE: 0});

		Object.keys(summary).reverse().forEach((property: string) => summaryData.push({id: property, title: property, value: summary[property]}));
		return summaryData;
	}

	private onChangeField = (val) => {
		this.setState({ selectedYear: val});
	}

	public render() {

		const {config } = this.props;

		return (
			<Query.One entity={CreditUserCount} args={{granted: true}}>
				{({ data,loading }) => {
					if (loading) {
						return <Loading key="loading" />;
					}
					if (!data) {
						return;
					}
					const pageCount = data.count;
					const params = {...mapCreditEntryParams(pageCount)};
					const res = {...params.params}
					return (
						<Query.Many entity={CreditEntriesUser} args={res}>
							{({ data,loading }) => {
								if (loading) {
									return <Loading key="loading" />;
								}

								if (!Array.isArray(data) || data.length === 0) {
									return;
								}
								
								return (
									<React.Fragment>
											<SeparatorView viewKey="select-separator" />
											{ config.enableYearFilter ? (
											<BlockView viewKey="dropdown">
												<div style={{display: 'flex'}}>
													<Label k="credit.filter.message" v="Credits earned:" />
													<DropdownSelect
														buttonProps={{
															minimal: true,
															small: true,
														}}
														options={yearOptions}
														value={this.state.selectedYear}
														onChange={(val)=>this.onChangeField(val)}
													/>
												</div>
											</BlockView>
											) : ''}
                                                <CreditSummaryView
                                                    blockData={this.getFilteredSummaryData(data)}
                                                    viewKey={"credit.earned"}
												/>
										</React.Fragment>
								);
							}}
						</Query.Many>
					)
				}}
			</Query.One>
		)
	}
}



// WEBPACK FOOTER //
// ./src/panels/creditSummary/TheAcademyCreditSummary.panel.tsx